export const SET_USER = 'SET_USER';
export const GET_USER = 'GET_USER';
export const SET_TOKEN = 'SET_USER';
export const LOGOUT = 'LOGOUT';